import { Table } from "antd";
import React, { FC } from "react";
import { CreditworthinessReportingAnalysis } from "../../../../../../../store/types/scoring.type";

const columns = [
  {
    title: "№",
    dataIndex: "key",
    width: 50,
  },
  {
    title: "Наименование коэффицента",
    dataIndex: "title",
  },
  {
    title: "Значение",
    dataIndex: "value",
    width: 115,
  },
  {
    title: "Балл",
    dataIndex: "point",
    width: 115,
  },
  {
    title: "Max балл",
    dataIndex: "maxPoint",
    width: 115,
  },
  {
    title: "Вес",
    dataIndex: "weight",
    width: 115,
  },
];

interface ReportingAnalysisTableProps {
  dataSource: CreditworthinessReportingAnalysis[];
}

export const ReportingAnalysisTable: FC<ReportingAnalysisTableProps> = (
  props
) => {
  const { dataSource } = props;

  return (
    <>
      <Table
        columns={columns}
        dataSource={dataSource}
        bordered
        pagination={false}
        summary={(pageData) => {
          let totalPoint = 0;
          let totalMaxPoint = 0;
          let totalWeight = 0;

          pageData.forEach(({ point, maxPoint, weight }) => {
            if (!isNaN(point) && !isNaN(maxPoint) && !isNaN(weight)) {
              totalPoint += +point;
              totalMaxPoint += +maxPoint;
              totalWeight += +weight;
            }
          });

          return (
            <>
              <Table.Summary.Row>
                <Table.Summary.Cell index={0} colSpan={3} align={"center"}>
                  Итого
                </Table.Summary.Cell>
                <Table.Summary.Cell index={3}>{totalPoint}</Table.Summary.Cell>
                <Table.Summary.Cell index={4}>
                  {totalMaxPoint}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={5}>{totalWeight}</Table.Summary.Cell>
              </Table.Summary.Row>
            </>
          );
        }}
      />
    </>
  );
};
